import { render, staticRenderFns } from "./patent.vue?vue&type=template&id=facd4b86&scoped=true&"
import script from "./patent.vue?vue&type=script&lang=js&"
export * from "./patent.vue?vue&type=script&lang=js&"
import style0 from "./patent.vue?vue&type=style&index=0&id=facd4b86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facd4b86",
  null
  
)

export default component.exports